import colors from 'Core/Styles/theme/foundations/colors';

const FORM_CONTROL = {
  marginBottom: '1rem'
};

const FORM_LABEL = {
  fontSize: 'sm',
  fontWeight: 'bold'
};

const LINK_STYLE = {
  fontSize: '18px',
  color: 'blue.500'
};

const PAGE_HEADERS = {
  fontSize: 'xl',
  fontWeight: 'bold'
};

const HIGHLIGHTED_TEXT = {
  fontSize: '3xl',
  fontWeight: 'extrabold',
  color: 'primary.500'
};

const TEXT_BASE = {
  margin: '0'
};

const TEXT_LABEL = {
  color: colors.appGrey,
  fontSize: 'xs'
};

const STATE_LIST = [
  'ANDAMAN & NICOBAR ISLANDS',
  'ANDHRA PRADESH',
  'ARUNACHAL PRADESH',
  'ASSAM',
  'BIHAR',
  'CHANDIGARH',
  'CHHATTISGARH',
  'DADRA AND NAGAR HAVELI AND DAMAN AND DIU',
  'DELHI',
  'GOA',
  'GUJARAT',
  'HARYANA',
  'HIMACHAL PRADESH',
  'JAMMU AND KASHMIR',
  'JHARKHAND',
  'KARNATAKA',
  'KERALA',
  'LADAKH',
  'LAKSHDWEEP',
  'MADHYA PRADESH',
  'MAHARASHTRA',
  'MANIPUR',
  'MEGHALAYA',
  'MIZORAM',
  'NAGALAND',
  'ODISHA',
  'PONDICHERRY',
  'PUNJAB',
  'RAJASTHAN',
  'SIKKIM',
  'TAMIL NADU',
  'TELANGANA',
  'TRIPURA',
  'UTTAR PRADESH',
  'UTTARAKHAND',
  'WEST BENGAL',
]

const CITY_LIST = [
  'AGARTALA',
  'AGRA',
  'AHMEDABAD',
  'AIZWAL',
  'AJMER',
  'ALIBAUG',
  'ALLAHABAD',
  'ALLEPPEY',
  'ALMORA',
  'ALSISAR',
  'ALWAR',
  'AMBALA',
  'AMLA',
  'AMRITSAR',
  'ANAND',
  'ANKLESHWAR',
  'ASHTAMUDI',
  'AULI',
  'AURANGABAD',
  'BADDI',
  'BADRINATH',
  'BALASINOR',
  'BALRAMPUR',
  'BAMBORA',
  'BANDHAVGARH',
  'BANDIPUR',
  'BANGALORE',
  'BARBIL',
  'BAREILLY',
  'BEHROR',
  'BELGAUM',
  'BERHAMPUR',
  'BETALGHAT',
  'BHANDARDARA',
  'BHARATPUR',
  'BHARUCH',
  'BHAVANGADH',
  'BHAVNAGAR',
  'BHILAI',
  'BHIMTAL',
  'BHOPAL',
  'BHUBANESHWAR',
  'BHUJ',
  'BIKANER',
  'BINSAR',
  'BODHGAYA',
  'BUNDI',
  'CALICUT',
  'CANANNORE',
  'CHAIL',
  'CHAMBA',
  'CHANDIGARH',
  'CHENNAI',
  'CHIKMAGALUR',
  'CHIPLUN',
  'CHITRAKOOT',
  'CHITTORGARH',
  'COIMBATORE',
  'COONOOR',
  'COORG',
  'CORBETT NATIONAL PARK',
  'CUTTACK',
  'DABHOSA',
  'DALHOUSIE',
  'DAMAN',
  'DANDELI',
  'DAPOLI',
  'DARJEELING',
  'DAUSA',
  'DEHRADUN',
  'DHARAMSHALA',
  'DIBRUGARH',
  'DIGHA',
  'DIU',
  'DIVE AGAR',
  'DOOARS',
  'DURGAPUR',
  'DURSHET',
  'DWARKA',
  'FARIDABAD',
  'FIROZABAD',
  'GANAPATIPULE',
  'GANDHIDHAM',
  'GANDHINAGAR',
  'GANGOTRI',
  'GANGTOK',
  'GARHMUKTESHWAR',
  'GARHWAL',
  'GAYA',
  'GHAZIABAD',
  'GOA',
  'GOKHARNA',
  'GONDAL',
  'GORAKHPUR',
  'GREATER NOIDA',
  'GULMARG',
  'GURGAON',
  'GURUVAYOOR',
  'GUWAHATI',
  'GWALIOR',
  'HALEBID',
  'HAMPI',
  'HANSI',
  'HARIDWAR',
  'HASSAN',
  'HOSPET',
  'HOSUR',
  'HUBLI',
  'HYDERABAD',
  'IDUKKI',
  'IGATPURI',
  'IMPHAL',
  'INDORE',
  'JABALPUR',
  'JAIPUR',
  'JAISALMER',
  'JALANDHAR',
  'JALGAON',
  'JAMBUGODHA',
  'JAMMU',
  'JAMNAGAR',
  'JAMSHEDPUR',
  'JAWHAR',
  'JHANSI',
  'JODHPUR',
  'JOJAWAR',
  'JORHAT',
  'JUNAGADH',
  'KABINI',
  'KALIMPONG',
  'KANATAL',
  'KANCHIPURAM',
  'KANHA',
  'KANPUR',
  'KANYAKUMARI',
  'KAPURTHALA',
  'KARGIL',
  'KARJAT',
  'KARNAL',
  'KARUR',
  'KARWAR',
  'KASARGOD',
  'KASAULI',
  'KASHID',
  'KASHIPUR',
  'KATRA',
  'KAUSANI',
  'KAZA',
  'KAZIRANGA',
  'KEDARNATH',
  'KHAJJIAR',
  'KHAJURAHO',
  'KHANDALA',
  'KHIMSAR',
  'KOCHIN',
  'KODAIKANAL',
  'KOLHAPUR',
  'KOLKATA',
  'KOLLAM',
  'KOTA',
  'KOTAGIRI',
  'KOTTAYAM',
  'KOVALAM',
  'KUFRI',
  'KULLU',
  'KUMARAKOM',
  'KUMBAKONAM',
  'KUMBALGARH',
  'KUMILY',
  'KURSEONG',
  'KUSHINAGAR',
  'LACHUNG',
  'LAKSHADWEEP',
  'LEH',
  'LONAVALA',
  'LOTHAL',
  'LUCKNOW',
  'LUDHIANA',
  'MADURAI',
  'MAHABALESHWAR',
  'MAHABALIPURAM',
  'MALAPPURAM',
  'MALPE',
  'MALSHEJ GHAT',
  'MALVAN',
  'MANALI',
  'MANDAVI',
  'MANDAWA',
  'MANDORMONI',
  'MANESAR',
  'MANGALORE',
  'MANMAD',
  'MARARRI',
  'MARCHULA',
  'MATHERAN',
  'MATHURA',
  'MCLEODGANJ',
  'MOHALI',
  'MORADABAD',
  'MORBI',
  'MOUNT ABU',
  'MUKTESHWAR',
  'MUMBAI',
  'MUNDRA',
  'MUNNAR',
  'MURUD JANJIRA',
  'MUSSOORIE',
  'MYSORE',
  'NADUKANI',
  'NAGAPATTINAM',
  'NAGARHOLE',
  'NAGAUR FORT',
  'NAGOTHANE',
  'NAGPUR',
  'NAHAN',
  'NAINITAL',
  'NALDHERA',
  'NANDED',
  'NAPNE',
  'NASIK',
  'NAVI MUMBAI',
  'NERAL',
  'NEW DELHI',
  'NILGIRI',
  'NOIDA',
  'OOTY',
  'ORCHHA',
  'OSIAN',
  'PACHMARHI',
  'PAHALGAM',
  'PALAMPUR',
  'PALANPUR',
  'PALI',
  'PALITANA',
  'PALLAKAD',
  'PANCHGANI',
  'PANCHKULA',
  'PANHALA',
  'PANNA',
  'PANTNAGAR',
  'PANVEL',
  'PARWANOO',
  'PATHANKOT',
  'PATIALA',
  'PATNA',
  'PATNITOP',
  'PELLING',
  'PENCH',
  'PHAGWARA',
  'PHALODI',
  'PINJORE',
  'PONDICHERRY',
  'POOVAR',
  'PORBANDAR',
  'PORT BLAIR',
  'POSHINA',
  'PRAGPUR',
  'PUNE',
  'PURI',
  'PUSKHAR',
  'PUTTAPARTHI',
  'RAI BAREILLY',
  'RAICHAK',
  'RAIPUR',
  'RAJAHMUNDRY',
  'RAJASTHAN',
  'RAJGIR',
  'RAJKOT',
  'RAJPIPLA',
  'RAJSAMAND',
  'RAM NAGAR',
  'RAMESHWARAM',
  'RAMGARH',
  'RANAKPUR',
  'RANCHI',
  'RANIKHET',
  'RANNY',
  'RANTHAMBORE',
  'RATNAGIRI',
  'RAVANGLA',
  'RISHIKESH',
  'RISHYAP',
  'ROHETGARH',
  'ROURKELA',
  'SAJAN',
  'SALEM',
  'SAPUTARA',
  'SASAN GIR',
  'SATTAL',
  'SAWAI MADHOPUR',
  'SAWANTWADI',
  'SECUNDERABAD',
  'SHARAVANBELGOLA',
  'SHILLONG',
  'SHIMLA',
  'SHIMLIPAL',
  'SHIRDI',
  'SHIVANASAMUDRA',
  'SIANA',
  'SILIGURI',
  'SILVASSA',
  'SIVAGANGA DISTRICT',
  'SOLAN',
  'SONAULI',
  'SRINAGAR',
  'SUNDERBAN',
  'SURAT',
  'TANJORE',
  'TAPOLA',
  'TARAPITH',
  'THANE',
  'THEKKADY',
  'THIRUVANANTHAPURAM',
  'THIRVANNAMALAI',
  'THRISSUR',
  'TIRUCHIRAPALLI',
  'TIRUPATI',
  'TIRUPUR',
  'UDAIPUR',
  'UDHAMPUR',
  'UDUPI',
  'UJJAIN',
  'UTTARKASHI',
  'VADODARA',
  'VAGAMON',
  'VAPI',
  'VARANASI',
  'VARKALA',
  'VELANKANNI',
  'VELLORE',
  'VERAVAL',
  'VIJAYAWADA',
  'VIKRAMGADH',
  'VISHAKAPATNAM',
  'WANKANER',
  'WAYANAD',
  'YAMUNOTRI',
  'YERCAUD',
  'YUKSOM',
]

export { FORM_CONTROL, FORM_LABEL, LINK_STYLE, PAGE_HEADERS, HIGHLIGHTED_TEXT, TEXT_BASE, TEXT_LABEL, STATE_LIST, CITY_LIST };
